import { MedicationAdministration} from "../../fhir";
import { ErrorMessage } from "../";

export enum ActionType {
  SetMedication = "SetMedication",
  SetAdministration = "SetAdministration",
  SetCards = "SetCards",
  SetCdsServices= "SetCdsServices",
  AddError = "AddError",
  ResetErrors = "ResetErrors",
}

export type Action =
  | { type: ActionType.SetMedication; payload: object }
  | { type: ActionType.SetAdministration; payload: MedicationAdministration }
  | { type: ActionType.AddError; payload: ErrorMessage[] }
  | { type: ActionType.ResetErrors; }

interface ISetMedication {
  type: ActionType.SetMedication;
  payload: any;
}

interface ISetAdministration {
  type: ActionType.SetAdministration;
  payload: any;
}

interface IAddError {
  type: ActionType.AddError;
  payload: ErrorMessage[];
}

interface IResetErrors {
  type: ActionType.ResetErrors;
}

const SetMedication = (value: any): ISetMedication => ({
  type: ActionType.SetMedication,
  payload: value,
});

const SetAdministration = (value: any): ISetAdministration => ({
  type: ActionType.SetAdministration,
  payload: value,
});

const AddError = (value: any): IAddError => ({
  type: ActionType.AddError,
  payload: value,
});

const ResetErrors = (): IResetErrors => ({
  type: ActionType.ResetErrors
});

export const Actions = {
  SetMedication,
  SetAdministration,
  AddError,
  ResetErrors
};
